/**
 * A key that survives retries.
 *
 * The same key must be reused when a submission is retried -- that is what
 * makes the offline queue and a double-tapped button safe -- so callers hold on
 * to it rather than generating a fresh one per attempt.
 */
export const newIdempotencyKey = (): string =>
    typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `k-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
